export const viewCommands = [
  { title: "编辑视图", command: "edit", icon: "svgo_edit" },
  { title: "复制视图", command: "copy", icon: "svgo_copy" },
  { title: "删除视图", command: "delete", icon: "svgo_delete" },
  { title: "取消隐藏", command: "unhide", icon: "svgo_unhide" }
]

export const viewColumns = [
  {
    label: "视图名称",
    value: "name",
    width: "220"
  },
  {
    label: "类型",
    value: "type",
    width: "90"
  }
]

export const typeOptions = [
  {
    label: "列表",
    value: "LIST"
  },
  {
    label: "树状",
    value: "TREE"
  },
  {
    label: "看板",
    value: "BOARD"
  },
  {
    label: "画册",
    value: "ALBUM"
  },
  {
    label: "甘特图",
    value: "GANTT"
  }
]

export const operationMap = {
  edit: "编辑",
  delete: "删除",
  sync: "同步",
  print: "打印",
  changeCharge: "更换负责人",
  addMember: "添加参与人",
  delMember: "移除参与人",
  lock: "锁定",
  unlock: "解锁"
}
